import { render, staticRenderFns } from "./commonTableUser.vue?vue&type=template&id=5b98e8da&"
import script from "./commonTableUser.vue?vue&type=script&lang=js&"
export * from "./commonTableUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports